export default __webpack_public_path__ + "static/media/screenContent1.320e01c8.jpg";